import React, { useState } from 'react'
import { useLocation, useParams } from 'react-router-dom';
import PeriodFilter from 'components/PeriodFilter/PeriodFilter';
//import axios from 'axios';
//URL
//import { GET_LIVRE_JOURNAL } from 'routes/api/endpoints';
import LivreJournal from './components/LivreJournal';
import GrandLivre from './components/GrandLivre';
import GrandLivreTiers from './components/GrandLivreTiers';
import Balance from './components/Balance';
import Bilan from './components/Bilan';
import CompteResultat from "./components/CompteResultat";
import SaisieEcritures from "./components/SaisieEcritures";
import PlanComptable from "./components/PlanComptable";
import "./components/style/style.css";


const ComptabilitePage = () => {
  const { clientID: dossier_id } = useParams();
  const location = useLocation();
  const isPlanComptableRoute = (location.pathname || "").includes("/comptabilite/plan-comptable");
  const [aff_livre,setAffLivre] = useState(true)
  const [aff_grandlivre,setAffGrandLivre] = useState(false)
  const [aff_grandlivre_tiers,setAffGrandLivreTiers] = useState(false)
  const [aff_balance,setAffBalance] = useState(false)
  const [aff_bilan,setAffBilan] = useState(false)
  const [aff_compteresultat, setAffCompteResultat] = useState(false)
  const [aff_saisie, setAffSaisie] = useState(false)
  
  // État du filtre de période
  const [periodFilter, setPeriodFilter] = useState({ 
    type: 'all', 
    startDate: null, 
    endDate: null 
  });

  const handleLivre = (e) =>{
    e.preventDefault()
    setAffLivre(true)
    setAffGrandLivre(false)
    setAffGrandLivreTiers(false)
    setAffBalance(false)
    setAffBilan(false)
    setAffCompteResultat(false)
    setAffSaisie(false)
  }
  const handleGrandLivre = (e) =>{
    e.preventDefault()
    setAffLivre(false)
    setAffGrandLivre(true)
    setAffGrandLivreTiers(false)
    setAffBalance(false)
    setAffBilan(false)
    setAffCompteResultat(false)
    setAffSaisie(false)
  }
  const handleGrandLivreTiers = (e) =>{
    e.preventDefault()
    setAffLivre(false)
    setAffGrandLivre(false)
    setAffGrandLivreTiers(true)
    setAffBalance(false)
    setAffBilan(false)
    setAffCompteResultat(false)
    setAffSaisie(false)
  }
  const handleBalance = (e) =>{
    e.preventDefault()
    setAffLivre(false)
    setAffGrandLivre(false)
    setAffGrandLivreTiers(false)
    setAffBalance(true)
    setAffBilan(false)
    setAffCompteResultat(false)
    setAffSaisie(false)
  }
  const handleBilan = (e) =>{
    e.preventDefault()
    setAffLivre(false)
    setAffGrandLivre(false)
    setAffGrandLivreTiers(false)
    setAffBalance(false)
    setAffBilan(true)
    setAffCompteResultat(false)
    setAffSaisie(false)
  }
  const handleCompteResultat = (e) => {
    e.preventDefault();
    setAffLivre(false);
    setAffGrandLivre(false);
    setAffGrandLivreTiers(false);
    setAffBalance(false);
    setAffBilan(false);
    setAffCompteResultat(true);
    setAffSaisie(false);
  }
  const handleSaisie = (e) => {
    e.preventDefault();
    setAffLivre(false);
    setAffGrandLivre(false);
    setAffGrandLivreTiers(false);
    setAffBalance(false);
    setAffBilan(false);
    setAffCompteResultat(false);
    setAffSaisie(true);
  }

  if (isPlanComptableRoute) {
    return (
      <div>
        <PlanComptable dossier_id={dossier_id} />
      </div>
    );
  }

  return (
    <div>
      <div className='buttons_compta'>
        <button
          type="button"
          className={`btn-compta-nav ${aff_livre ? "is-active" : ""}`}
          onClick={handleLivre}
        >
          Journal
        </button>
        <button
          type="button"
          className={`btn-compta-nav ${aff_grandlivre ? "is-active" : ""}`}
          onClick={handleGrandLivre}
        >
          Grand Livre
        </button>
        <button
          type="button"
          className={`btn-compta-nav ${aff_grandlivre_tiers ? "is-active" : ""}`}
          onClick={handleGrandLivreTiers}
        >
          Grand Livre tiers
        </button>
        <button
          type="button"
          className={`btn-compta-nav ${aff_balance ? "is-active" : ""}`}
          onClick={handleBalance}
        >
          Balance Générale
        </button>
        <button
          type="button"
          className={`btn-compta-nav ${aff_bilan ? "is-active" : ""}`}
          onClick={handleBilan}
        >
          Bilan
        </button>
        <button
          type="button"
          className={`btn-compta-nav ${aff_compteresultat ? "is-active" : ""}`}
          onClick={handleCompteResultat}
        >
          Compte de Résultat
        </button>
        <button
          type="button"
          className={`btn-compta-nav ${aff_saisie ? "is-active" : ""}`}
          onClick={handleSaisie}
        >
          Saisie manuelle
        </button>
      </div>
      
      {/* Filtre de période - Affiché uniquement pour les documents comptables */}
      {!aff_saisie && (
        <div style={{ padding: '20px 20px 10px', backgroundColor: '#f0f5f6' }}>
          <PeriodFilter 
            onFilterChange={setPeriodFilter}
            initialFilter={periodFilter}
          />
        </div>
      )}
      
      {
        aff_livre && <LivreJournal dossier_id={dossier_id} date_debut={periodFilter.startDate} date_fin={periodFilter.endDate} />
      }
      {
        aff_grandlivre && <GrandLivre dossier_id={dossier_id} date_debut={periodFilter.startDate} date_fin={periodFilter.endDate} />
      }
      {
        aff_grandlivre_tiers && <GrandLivreTiers dossier_id={dossier_id} date_debut={periodFilter.startDate} date_fin={periodFilter.endDate} />
      }
      {
        aff_balance && <Balance dossier_id={dossier_id} date_debut={periodFilter.startDate} date_fin={periodFilter.endDate} />
      }
      {
        aff_bilan && <Bilan dossier_id={dossier_id} date_debut={periodFilter.startDate} date_fin={periodFilter.endDate} />
      }
      {
        aff_compteresultat && <CompteResultat dossier_id={dossier_id} date_debut={periodFilter.startDate} date_fin={periodFilter.endDate} />
      }
      {
        aff_saisie && <SaisieEcritures dossier_id={dossier_id} />
      }
    </div>
  )
}

export default ComptabilitePage